import request from '@/utils/request'
// 积分商品分页
export async function api_getPointmallPage(params) {
  return request({
    url: '/rest/point/mall/page',
    method: 'get',
    params,
  })
}
// 商品详情
export async function api_getPointMall(params) {
  return request({
    url: '/rest/point/mall/get',
    method: 'get',
    params,
  })
}
// 创建积分商品
export async function api_postAddPointMallCreate(data) {
  return request({
    url: '/rest/point/mall/create',
    method: 'post',
    data,
  })
}
// 编辑积分商品
export async function api_putUpdatePointMallCreate(data) {
  return request({
    url: '/rest/point/mall/update',
    method: 'post',
    data,
  })
}

// 获取积分流水列表数据
export async function api_putPointMallEffective(params) {
  return request({
    url: '/rest/point/mall/effective',
    method: 'put',
    params,
  })
}
// 获取积分商品兑换记录列表
export async function api_getPointMallRecordList(params) {
  return request({
    url: '/rest/point/mall/record',
    method: 'get',
    params,
  })
}
// 积分商品退款(积分)
export async function api_getRefundPoint(params) {
  return request({
    url: '/rest/point/mall/refundPoint',
    method: 'get',
    params,
  })
}
// 积分商品退款(积分+现金)
export async function api_getRefund(params) {
  return request({
    url: '/rest/point/mall/refund',
    method: 'get',
    params,
  })
}
// 积分商品兑换记录导出
export async function api_getExport(params) {
  return request({
    url: '/rest/point/mall/record/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}